import React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { academicCards } from '../../../Content/Bio';
import Card from './Card';
import { Container } from './styles';

const AcademicEducation = () => {
  return (
    <Container>
      <h3>Academic Education</h3>

      <div className="scrollContainer">
        {
          academicCards.map((card, index) => (
            <Card key={index} {...card} />
          ))
        }
      </div>

    </Container>
  );
};

export default AcademicEducation;
